export const MARKET_OVERVIEW_ALL = 'fb81b2c8-040f-4119-a8a9-c5856dfc74fe';
export const MARKET_OVERVIEW_IGC = '5dc775f7-2d18-4771-b584-5b6102cd4cc4';
export const MARKET_OVERVIEW_HYC = '131e4113-be9b-43ab-baf8-3951807fbdb0';
export const MARKET_OVERVIEW_CONSUMER = '2f8f92a4-75d7-40ed-86c4-eaf330beafa2';
export const BOND_SCREENER = 'a4e55b04-110a-43a1-9fec-f70ab4903a7f';
export const CORPORATE_BOND_SCREENER = '30fb6811-e9e5-4ec8-85df-b41eef13cbc8';
export const CREDIT_FLOW_ARTICLES = '49fd7eaa-967d-4b8e-b502-a119446ff2c0';
export const BWICS = 'b1acab64-8462-4693-bc61-2f2966c568c6';
export const TRACE = '0f8d4388-be36-4c67-a835-b93495502129';
export const LEAGUE_TABLE = 'd1a2d5ca-8d16-44a6-a1d0-a38396cdeb77';
export const LOAN_LEVEL_DATA = '6da9bda0-e627-4611-a071-d4bf034c4d83';
export const NEW_ISSUER_PIPELINE = '2fd26681-f4f5-4eb6-aa95-4a780fe1b353';
export const OPEN_MARKET = '9ff9a746-7d44-4454-8024-7594ec6ef9af';
export const PORTFOLIO_MONITOR = 'dbd410e7-911f-4d67-b0b4-050f4a36bca4';
export const RESEARCH = '74ba724f-75ac-4ae5-a66c-ee61a82afbb2';
export const NEW_ISSUE_STATS = 'f3aa5ab3-7f2b-4302-b719-3a299eeb8bb9';
export const INVESTOR_SET = '6f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const CAPEDGE_HOME = '1f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const CALENDAR = '2f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const COURT = '3f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const EARNINGS_CALENDAR = '4f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const INSIDER = '5f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const SPLITS = '6f8fc265-8ffe-4ba3-ad3d-6b163ef56949';
export const EARNINGS = '7f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const INDUSTRIAL = '8f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const CRYPTO = '9f8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const ISSUE_REGISTRATION = '1d8fc265-8ffe-4ba3-ad3d-6b163ef56948';
export const REDDIT = '1d8fc265-8ffe-4ba3-ad3d-6b163ef56949';
export const ACTIVE_CALENDAR = '395dcdd4-03f6-4f69-b472-d0787a97cd28';
export const CFX_INDICES = '5d76d319-c197-4be0-bbde-38536bfbd208';
export const CFX_CORPORATE_INDICES = '0caf7895-c6a9-49b0-825c-e4607191279b';
export const IG_ACTIVE_CALENDAR = 'ef8648d9-2774-42c7-b35d-e99d08971595';
export const IG_PIPELINE = '7adf71ad-6570-4120-ab59-7b40a56cddef';
export const HYC_ACTIVE_CALENDAR = 'c2fc58d5-c484-4bb8-93cb-c353578ce961';
export const HYC_PIPELINE = '0c8c4821-fc94-48af-8604-72dfc390284d';
